export class Country {
  id: number;
  countryName: string;
  countryCode: string;
  phoneCode: string;
  continent: string;
  created_at: string;
  updated_at: string;
  deleted_at: string;
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/utils/objects/country.ts